import { SelectedPicker, useComboSelectionContext } from '../state/combo-selection';
import { useMenuPicker } from '../state/menu-picker';

import { formatCentsToDollars } from '.';

export const getComboPickerExtraPriceCents = (
  selectedPickers: Record<string, SelectedPicker>
) =>
  Object.values(selectedPickers).reduce((total, picker) => total + picker.priceCents, 0);

export const getComboUnitPriceCents = ({
  menuPickerPriceCents,
  comboBasePriceCents,
  selectedPickers,
}: {
  menuPickerPriceCents: number;
  comboBasePriceCents: number;
  selectedPickers: Record<string, SelectedPicker>;
}) =>
  menuPickerPriceCents +
  comboBasePriceCents +
  getComboPickerExtraPriceCents(selectedPickers);

export const useMenuItemPricePreview = ({
  menuPicker,
  quantity,
}: {
  menuPicker: ReturnType<typeof useMenuPicker>;
  quantity: number;
}) => {
  const { isComboEnabled, selectedPickers } = useComboSelectionContext();

  if (!isComboEnabled && !menuPicker.isComboRequired) {
    const totalPriceCents = quantity * menuPicker.priceCents;
    return {
      totalPriceCents,
      formattedTotalPrice: formatCentsToDollars(totalPriceCents) ?? '',
    };
  }

  const totalUnitPriceCents = getComboUnitPriceCents({
    menuPickerPriceCents: menuPicker.priceCents,
    comboBasePriceCents: menuPicker.query.data?.combo?.basePriceCents ?? 0,
    selectedPickers,
  });
  const totalPriceCents = quantity * totalUnitPriceCents;
  const formattedTotalPrice = formatCentsToDollars(totalPriceCents) ?? '';

  return {
    totalPriceCents,
    formattedTotalPrice,
  };
};
